import utils from 'utils'
import globalFnFactory from 'components/globalFn/globalFnFactory'
import Invoice from './model/Invoice'
import Customer from './model/Customer'
import Goods from './model/Goods'
import Sale from './model/Sale'
import Ukey from './model/Ukey'
import modalInvoiceTitle from './view/modalInvoiceTitle.html'
import {
    submitCheck,
} from './invoiceValidate'
import stockService from '../../../../common/services/stockService'

const globalFn = globalFnFactory()
export default class InvoiceEditCtrl {
    constructor($scope, httpRequest, $state, $stateParams, $http, logger, invoiceOpenService, sweetalert, operationService, $uibModal, scrollService, $filter, buyerChecker) {
        httpRequest.post_getEnableBankOfOrg().then(res => {
            $scope.saleBankList = res.data.value
        })
        // 是否详情页 默认值
        $scope.detailFlag = $stateParams.detailFlag // 是详情页
        $scope.pagingFlag = $stateParams.pagingFlag // 商品列表是否需要分次加载
        $scope.isAdd = $state.current.name.indexOf('add') > -1 ? true : false
        if ($scope.isAdd) {
            updateScanlen()
        }
        $state.current.name.split('.').forEach(i => {
            if (i == 'workspace') $scope.haveBorder = true
            if (i == 'redInfo') $scope.isRedInfo = true
            if (i == 'redInfoInv') $scope.isOpenRedInv = true
            if (i == 'cancelInvoice') $scope.isCancelReopenInv = true
        })
        // 如果是控制台则增加样式
        // if ($state.current.name.indexOf('workspace') > -1) {
        //     $scope.haveBorder = true
        // }
        // 红字信息表开票
        // if ($state.current.name.indexOf('redInfo') != -1) {
        //     $scope.isRedInfo = true
        // }
        // 红字信息表红冲
        if ($stateParams.infoId) {
            $scope.parentInfoId = $stateParams.infoId
        }
        // 已开具列表普票红冲
        // if ($state.current.name.indexOf('redInfoInv') != -1) {
        //     $scope.isOpenRedInv = true
        // }
        // 发票重开 调用新增逻辑
        if ($stateParams.canceledInvoiceId) {
            $scope.canceledInvoiceId = $stateParams.canceledInvoiceId
        }

        // 隐藏一二级菜单
        if ($stateParams.detailFlag === true) {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        if ($scope.invoice && $scope.invoice.customer) {
            $scope.$watch('invoice.customer.custCreditCode', () => {
                $scope.invoice.customer.custCreditCode = $scope.invoice.customer.custCreditCode && $scope.invoice.customer.custCreditCode.toUpperCase()
            })
        }

        $scope.totalInvoice = 1
        $scope.currentInvoice = 1
        $scope.waitId = $stateParams.waitId
        $scope.parentInvoiceId = $stateParams.parentInvoiceId || $stateParams.infoId // 红冲父票id
        let paramArr = []
        if ($stateParams.waitId) {
            paramArr = $stateParams.waitId.split('options')
            $scope.waitId = paramArr[0]
            if (paramArr.length > 1) {
                const invoiceArr = JSON.parse(paramArr[1])
                $scope.totalInvoice = invoiceArr.length
                $scope.currentInvoice = invoiceArr.indexOf($scope.waitId) + 1
            }
        }
        $scope.showOperateBtn = function (flag) {
            $scope.showOperate = flag
            if ($scope.currentInvoice > 1 && $scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = true
            } else if ($scope.currentInvoice > 1) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = false
            } else if ($scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = false
                $scope.showOperateRight = true
            }
        }
        // 翻页按钮
        $scope.changepage = function (val) {
            const list = JSON.parse(paramArr[1])
            if (val > 0) {
                $state.go('workspace.item.detail', {
                    waitId: `${list[$scope.currentInvoice]}options${JSON.stringify(list)}`,
                })
            } else {
                $state.go('workspace.item.detail', {
                    waitId: `${list[$scope.currentInvoice - 2]}options${JSON.stringify(list)}`,
                })
            }
        }
        /**
         * 根据开票点和发票种类获取库存数量和最新发票代码号码
         */
        function getStockByUkey() {
            invoiceOpenService.getStockByUkey(
                $scope.invoice.ukey.ukeyList,
                $scope.invoice.ukey.ukeyId,
                $scope.invoice.invType,
            ).then((obj) => {
                $scope.hintMsg = `剩余发票数量:${obj.sum}`
                $scope.invoice.invoiceCode = obj.invoiceCode
                $scope.invoice.invoiceNumber = obj.invoiceNumber
            }, (error) => {
                $scope.hintMsg = error
                $scope.invoice.invoiceCode = ''
                $scope.invoice.invoiceNumber = ''
            })
        }
        /**
         * 根据发票开票点ID获取开票点对象
         */
        function getSelectedUkey() {
            let selectedUkey
            $scope.invoice.ukey.ukeyList.forEach((ukey) => {
                if ($scope.invoice.ukey.ukeyId === ukey.ukeyId) {
                    selectedUkey = ukey
                    // $scope.invoice.ukey = new Ukey().fromUkey(ukey)
                }
            })
            return selectedUkey
        }
        /**
         * 获取发票限额
         */
        function getQuotasByUkey() {
            httpRequest.get_getTaxDisk($scope.invoice.ukey.ukeyId).then((res) => {
                const data = res.data.value
                $scope.invoice.ukey.quotas['0'] = data.specialQuota
                $scope.invoice.ukey.quotas['2'] = data.generalQuota
                $scope.invoice.ukey.quotas['51'] = data.electronicQuota
                // 金税盘机器号
                $scope.invoice.diskNo = data.diskNo
                utils.loaded()
            })
        }
        // 分页获取详情数据
        function getwaitListpage(pageInfo) {
            httpRequest.post_getPageInvoiceWaitDetail(pageInfo).then((res) => {
                $scope.currentDetail = null
                $scope.currentDetail = res.data.value
                if ($scope.detailFlag && $scope.currentDetail.isLastPage && $scope.currentDetail.size < 20) {
                    $scope.detailWaitInfo.waitDetailList = $scope.detailWaitInfo.waitDetailList ? $scope.detailWaitInfo.waitDetailList.concat($scope.currentDetail.list) : [].concat($scope.currentDetail.list)
                } else {
                    $scope.detailWaitInfo.waitDetailList = $scope.currentDetail.list
                }
                $scope.invoice = new Invoice($scope.detailWaitInfo)
                $scope.newDetails = []
                $scope.newDetails = $scope.invoice.details
                utils.loaded()
            })
        }
        $scope.loadSize = 50 // 默认一次跨度200条
        $scope.pageParam = {
            pageNum: 1,
            pageSize: $scope.loadSize,
            param: {
                invoiceID: $scope.waitId,
            },
        }
        /**
         * 初始化发票对象
         * @return {scope}
         */
        async function makeInvoice() {
            $scope.invoice = new Invoice()
            if ($scope.waitId) {
                const detailParam = {
                    waitId: $scope.waitId,
                }
                if ($stateParams.detailFlag) {
                    // 详情页needDetail=false 明细调用明细接口
                    detailParam.needDetail = false
                }
                utils.loading('正在加载数据，请耐心等待......')
                httpRequest.get_queryOvatInvoiceWait(detailParam).then((res) => {
                    $scope.invoice = new Invoice(res.data.value)
                    for (let i = 0; i < $scope.invoice.details.length; i++) {
                        $scope.invoice.details[i].adValoremTotal = (+$scope.invoice.details[i].adValoremTotal).toFixed(2)
                        $scope.invoice.details[i].amount = (+$scope.invoice.details[i].amount).toFixed(2)
                    }
                    // for (const index in $scope.invoice.details) {
                    //     $scope.invoice.details[index].adValoremTotal = (+$scope.invoice.details[index].adValoremTotal).toFixed(2)
                    //     $scope.invoice.details[index].amount = (+$scope.invoice.details[index].amount).toFixed(2)
                    // }
                    if ($scope.pagingFlag) {
                        $scope.invoice.isEditPage = true
                    }
                    if ($scope.isOpenRedInv) { // 已开红冲清空billcode
                        $scope.invoice.billCode = ''
                    }
                    if ($stateParams.detailFlag) {
                        $scope.detailWaitInfo = res.data.value
                        if ($scope.detailWaitInfo.isList === '0') {
                            $scope.invoice = new Invoice($scope.detailWaitInfo)
                            $scope.newDetails = []
                            $scope.newDetails = $scope.invoice.details
                            utils.loaded()
                        } else {
                            getwaitListpage($scope.pageParam)
                        }
                        // 有清单 总金额不按照列表结算，按列头赋值 --start
                        $scope.detailAdValoremTotal = $scope.detailWaitInfo.adValoremTotal
                        $scope.detailTotalAmt = $scope.detailWaitInfo.totalAmt
                        $scope.detailChineseTotal = globalFn.digitUppercase($scope.detailWaitInfo.adValoremTotal)
                        $scope.detailTotalTaxamt = $scope.detailWaitInfo.totalTaxamt
                        // 有清单 总金额不按照列表结算，按列头赋值 --end
                    } else {
                        if ($scope.invoice.isRed == 1 && $scope.invoice.isList == 1) {
                            httpRequest.post_getPageInvoiceDetail({
                                pageNum: 0,
                                pageSize: 0,
                                param: {
                                    "invoiceCode": $scope.invoice.blueInvoiceCode,
                                    "invoiceNumber": $scope.invoice.blueInvoiceNumber
                                },
                            }).then(res => {
                                $scope.newList = res.data.value.list
                            })
                        }
                        utils.loaded()
                        $scope.isEdit = true
                        getStockByUkey()
                        getQuotasByUkey()
                    }
                })
            } else if ($scope.isOpenRedInv) {
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                httpRequest.post_getOvatInvoice($scope.parentInvoiceId).then((res1) => {
                    const blueInvoice = res1.data.value
                    $scope.invoice.invType = blueInvoice.invType
                    $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                    if (res1.data.value.isList == 1) {
                        httpRequest.post_getPageInvoiceDetail({
                            pageNum: 0,
                            pageSize: 0,
                            param: {
                                invoiceID: $scope.parentInvoiceId,
                            },
                        }).then((res) => {
                            blueInvoice.invoiceDetailList = res.data.value.list
                            $scope.newList = res.data.value.list
                            $scope.blueInvoice = blueInvoice
                            $scope.invoice.fromBlue(blueInvoice)
                            $scope.invoice.remark = `对应正数发票代码:${blueInvoice.invoiceCode}号码:${blueInvoice.invoiceNumber}`
                        })
                    } else {
                        $scope.blueInvoice = blueInvoice
                        $scope.invoice.fromBlue(blueInvoice)
                    }
                    getStockByUkey()
                    getQuotasByUkey()
                })
            } else if ($scope.parentInfoId) {
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                httpRequest.get_getOvatInvoiceWaitByInfoId($scope.parentInfoId).then((res1) => {
                    // const blueInvoice = res1.data.value
                    // $scope.blueInvoice = blueInvoice
                    // $scope.invoice.fromBlue(blueInvoice)
                    $scope.invoice = new Invoice(res1.data.value)
                    // $scope.invoice.invType = $stateParams.invType
                    $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                    //下载的红字信息表没有diskId
                    if (!$scope.invoice.ukey.ukeyId) {
                        $scope.invoice.ukey.ukeyId = JSON.parse(localStorage.user_info).sysUkeyList[0].ukeyId
                        $scope.changerUkeyId()
                    } else {
                        getStockByUkey()
                        getQuotasByUkey()
                    }
                    $scope.invoice.ukey.openPeople = $scope.invoice.ukey.openPeople || JSON.parse(localStorage.user_info).user.realName
                })
            } else if ($scope.isCancelReopenInv) {
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                httpRequest.post_getOvatInvoice($scope.canceledInvoiceId).then((res1) => {
                    const blue = res1.data.value
                    if (res1.data.value.isList == 1) {
                        httpRequest.post_getPageInvoiceDetail({
                            pageNum: 0,
                            pageSize: 0,
                            param: {
                                invoiceID: $scope.canceledInvoiceId,
                                needSumLine: false
                            },
                        }).then((res) => {
                            blue.invoiceDetailList = res.data.value.list
                            markCancelBlue(blue, waitIdRes)
                        })
                    } else {
                        markCancelBlue(blue, waitIdRes)
                    }
                })
            } else {
                $scope.invoice = new Invoice()
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                $scope.invoice.invType = $stateParams.invType
                if ($state.current.name.indexOf('red') >= 0) {
                    $scope.invoice.$isRed = '1'
                }
                $scope.changerUkeyId()
            }
            // $scope.invoice.$isRed = '1'
        }

        function markCancelBlue(buleInvoice, waitIdRes) {
            let blue = buleInvoice
            if (blue.isRed == '1') {
                $scope.isRed = '1'
                $scope.invoice.$isRed = '1'
                $scope.invoice.redToRed(blue)
                $scope.invoice.invType = blue.invType
                $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                $scope.invoice.billCode = blue.billCode
                $scope.invoice.invoiceSource = blue.invoiceSource
            } else {
                $scope.invoice = new Invoice()
                $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                $scope.invoice.invType = $stateParams.invType
                $scope.invoice.invoiceDate = `${$filter('date')(new Date(), 'yyyy-MM-dd')} 00:00:00`
                $scope.copyInvoice(blue)
                $scope.invoice.billCode = blue.billCode
                $scope.invoice.invoiceSource = blue.invoiceSource
            }
            $scope.invoice.ukey.ukeyId = blue.ukeyId
            $scope.invoice.ukeyId = blue.ukeyId
            $scope.changerUkeyId()
            return blue
        }
        // edit by fwc----->
        $scope.onScrollTop = function () {
            $scope.pageParam = scrollService.onScrollTop($scope.currentDetail, $scope.pageParam, $scope.loadSize, getwaitListpage)
        }
        $scope.onScrollDown = function () {
            $scope.pageParam = scrollService.onScrollDown($scope.currentDetail, $scope.pageParam, $scope.loadSize, getwaitListpage)
        }
        // edit by fwc<-----
        /**
         * 获取清单最大行数作为invoice对象属性
         */
        function getGoodsLimit(invType) {
            httpRequest.get_getLimitNumber(invType).then((res) => {
                if (res.data.success) {
                    $scope.invoice.limitNumber = res.data.value
                }
            })
        }
        $scope.init = async function init() {
            makeInvoice()
            if ($scope.invoice.invType == '51' || $state.current.name.indexOf('eleInvoice.add') > -1) {
                getGoodsLimit('51') // 电子票
            } else {
                getGoodsLimit() // 专普
            }
            const typecodeArr = ['zero_tax']
            $scope.dictionary = {}
            const disctDataRes = await httpRequest.get_dictByTypeArr(JSON.stringify(typecodeArr))
            Object.assign($scope.dictionary, disctDataRes.data.value)
            httpRequest.post_qryFlowIsValid({
                approveCode: 'opened_invoice_approve',
            }).then((res) => {
                // 开启审批流
                $scope.isFlowOpened = res.data.value
            })
        }

        $scope.init()
        $scope.selectedRows = []
        $scope.createTime = new Date()
        // TODO1 采用新的控件
        $scope.qryCustNameList = function qryCustNameList($item) {
            return $http.post(`${host.etcloudOvat}settings/sysCustomer/qryByCodeOrName`, $item).then((response) => response.data.value.map((item) => $.extend({}, {
                custCodeAndcustName: `${item.customerName} ${item.creditCode}`,
            }, item)))
        }
        $scope.selectCust = function selectCust($item) {
            $scope.invoice.customer = new Customer().fromCustomer($item)
        }

        // TODO1 采用新的控件 end
        $scope.copyInvoice = function copyInvoice(item) {
            $scope.selectedRows = []
            $scope.invoice.sale = new Sale(item)
            $scope.invoice.customer = new Customer().fromInvoice(item)
            $scope.invoice.adValoremTotal = item.adValoremTotal
            $scope.invoice.totalAmt = item.totalAmt
            $scope.invoice.totalTaxamt = item.totalTaxamt
            $scope.invoice.remark = item.remark
            $scope.invoice.isTax = item.isTax
            // $scope.invoice = new Invoice(item)
            const details = item.waitDetailList || item.invoiceDetailList || []
            $scope.invoice.details = []
            details.forEach((detail) => {
                const goods = new Goods().fromInvoiceDetail(detail, $scope.invoice.invType)
                if (goods.balance) {
                    $scope.invoice.remark = `差额征税：${goods.balance.toFixed(2)}。`
                }
                $scope.invoice.details.push(goods)
            })
            $scope.invoice.isList = item.isList
        }

        $scope.copyFromBlue = function copyFromBlue(item) {
            $scope.blueInvoice = item
            $scope.invoice.fromBlue(item)
            $scope.newList = item.invoiceDetailList
            // $scope.invoice.adValoremTotal = item.adValoremTotal
            // $scope.invoice.totalAmt = item.totalAmt
        }

        // 选择开票点
        $scope.changerUkeyId = function changerUkeyId() {
            getStockByUkey()
            const selectedUeky = getSelectedUkey()
            $scope.invoice.ukey = new Ukey().fromUkey(selectedUeky)
            $scope.invoice.ukey.ukeyList.forEach((item) => {
                if (item.ukeyId == $scope.invoice.ukey.ukeyId) {
                    $scope.invoice.sale.saleBank = item.bank + ' ' + item.bankAccount // 销方开户银行 ,
                    $scope.invoice.sale.saleBankAccount = '' // 销方开户银行账号
                }
            })
            getQuotasByUkey()
        }
        $scope.goListPage = function goListPage() {
            if ($scope.invoice.invType === '51') {
                $state.go('outputManage.FOManage.eleInvoice.list')
            } else if ($scope.isOpenRedInv) {
                $state.go('outputManage.billManage.openedInvoice.list')
            } else if ($scope.isRedInfo) {
                $state.go('outputManage.FOManage.redInfo.list')
            } else if ($scope.isCancelReopenInv) {
                $state.go('outputManage.billManage.cancelInvoice.list')
            } else {
                $state.go('outputManage.FOManage.invoice.list')
            }
        }
        $scope.scratch = function scratch() {
            buyerChecker.checkBuyerCreditCode($scope.invoice.toWaitDTO().custCreditCode, $scope.invoice.toWaitDTO().creditType).then(() => {
                invoiceOpenService.checkAndscratch($scope.invoice.toWaitDTO()).then((res) => {
                    $scope.invoice.remark = res.data.value.remark
                    logger.logSuccess('暂存成功')
                }, (error) => {
                    logger.logError(error)
                })
            })
        }
        // rewrite
        function cbChangeUnionTypeOpen(data) {
            if (data != null) {
                if (!Object.prototype.hasOwnProperty.call(data, 'value')) {
                    logger.logError(data.retmsg)
                    utils.loaded()
                    return
                }
                const SIDParam = $.parseJSON(data.value)
                // console.log(SIDParam)
                if (SIDParam.InfoTypeCode[8] !== $scope.selectedInvoiceNum) { // 当前代码段和选择代码段不一致 切换号码段并开票
                    invoiceOpenService.queryInvoiceStock().then((res) => { // 金税盘所有库存
                        let param = getChangeObj($scope.selectedInvoiceNum, res) // 获取下一张票
                        if (JSON.stringify(param) !== '{}') { // 有票切换票卷并开票
                            stockService.changeInvoiceUnionType(param).then(() => {
                                $scope.printFlag ? openAndPrint($scope.newOpenItem) : open($scope.newOpenItem) // 直接开票
                            })
                        } else {
                            //12位代码：第12位代表联次，4代表两联，5代表五联；
                            //10位代码：第9位代表联次，2代表两联，5代表五联
                            const inv2Aarry10 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[8] == '2'))
                            const inv2Aarry12 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[11] == '4'))
                            const inv2Aarry = [].concat(inv2Aarry10).concat(inv2Aarry12)

                            const inv5Aarry10 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[8] == '5')) // 过滤出纸质票
                            const inv5Aarry12 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[11] == '5')) // 过滤出纸质票
                            const inv5Aarry = [].concat(inv5Aarry10).concat(inv5Aarry12)

                            if ($scope.selectedInvoiceNum == '2' && inv2Aarry.length == 0) {
                                utils.loaded()
                                logger.logError('发票库存不足')
                            }
                            if ($scope.selectedInvoiceNum == '5' && inv5Aarry.length == 0) { // 5联票用完切换
                                utils.loaded()
                                sweetalert.swal({
                                    title: '操作提醒',
                                    text: '当前开票点/金税盘不存在5联式的空白发票，是否继续开具2联式的发票？',
                                    showCancelButton: true,
                                    confirmButtonColor: '#0096e7',
                                    confirmButtonText: '开票',
                                    cancelButtonText: '取消',
                                    closeOnConfirm: true,
                                    closeOnCancel: true,
                                }, (isConfirm) => {
                                    if (isConfirm) {
                                        param = getChangeObj('2', res) // 切换2联发票开票
                                        if (JSON.stringify(param) !== '{}') {
                                            utils.loading('开票中，请耐心等待')
                                            stockService.changeInvoiceUnionType(param).then(() => {
                                                $scope.printFlag ? openAndPrint($scope.newOpenItem) : open($scope.newOpenItem) // 直接开票
                                            })
                                        } else {
                                            logger.logError('发票库存不足')
                                        }
                                    }
                                })
                            }
                        }
                    })
                } else {
                    $scope.printFlag ? openAndPrint($scope.newOpenItem) : open($scope.newOpenItem) // 直接开票
                }
            } else {
                utils.loaded()
                logger.logError('读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!')
            }
        }

        function getChangeObj(changeInv, datalist) { // 返回要切换的发票卷信息
            let param = {}
            // let invAarry = datalist.filter(item => (item.invoiceType == "2" && item.categoryCode[8] == changeInv)) //过滤出纸质票
            // 10位发票 2联5联公用
            let invAarry = datalist.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[7] == '6' && item.categoryCode[8] == changeInv)) // 过滤出纸质票
            // 12位 2联
            if (changeInv == '2') {
                const invAarry2 = datalist.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[10] == '0' && item.categoryCode[11] == '4')) // 过滤出纸质票
                invAarry = invAarry.concat(invAarry2)
            }
            if (changeInv == '5') {
                const invAarry3 = datalist.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[10] == '0' && item.categoryCode[11] == '5')) // 过滤出纸质票
                invAarry = invAarry.concat(invAarry3)
            }
            // 12位 5联
            if (invAarry.length > 0 && (changeInv == '2' || changeInv == '5')) { // 金税盘存在联次changeInv的发票卷 返回发票卷参数
                let num = -1
                for (let i = 0; i < invAarry.length; i++) {
                    if (invAarry[i].collectCount > 0) {
                        num = i
                        break
                    }
                }
                if (num >= 0) {
                    param = {
                        invType: '2',
                        invCode: invAarry[num].categoryCode,
                        startNumber: invAarry[num].startNumber,
                    }
                }
            }
            return param
        }

        function openIvoiceCofirm(confirmMsg) { // openType 开票类型 批量或者单张
            $uibModal.open({
                templateUrl: 'paperInvoiceNum3.html',
                controller: ['$scope', '$uibModalInstance', 'items1', 'invoiceOpenService', 'logger', function ctrl(scope, uibModalInstance, items1, invoiceOpenService, logger) {
                    utils.loading('开票信息获取中')
                    scope.ivoiceNum = '2' // 默认2联式发票
                    scope.confirmMsg = items1
                    scope.cancel = function cancel() {
                        uibModalInstance.close()
                    }
                    scope.ok = function ok() {
                        uibModalInstance.close(scope.ivoiceNum)
                    }
                    let inv2Aarry = []
                    let inv5Aarry = []
                    scope.ukey = JSON.parse(localStorage.user_info).sysUkeyList.filter(i => {
                        return i.diskCode == localStorage.currentDiskCode
                    })[0]
                    invoiceOpenService.queryInvoiceStock().then((res) => { // 金税盘所有库存
                        const inv2Aarry10 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[7] == '6' && item.categoryCode[8] == '2'))
                        const inv2Aarry12 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[10] == '0' && item.categoryCode[11] == '4'))
                        inv2Aarry = [].concat(inv2Aarry10).concat(inv2Aarry12)

                        const inv5Aarry10 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[7] == '6' && item.categoryCode[8] == '5')) // 过滤出纸质票
                        const inv5Aarry12 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[10] == '0' && item.categoryCode[11] == '5')) // 过滤出纸质票
                        inv5Aarry = [].concat(inv5Aarry10).concat(inv5Aarry12)
                        scope.invoiceCode = inv2Aarry[0] ? inv2Aarry[0].categoryCode : ''
                        scope.invoiceNumber = inv2Aarry[0] ? inv2Aarry[0].startNumber : ''

                    }, err => {
                        logger.logError(err)
                    }).finally(() => {
                        utils.loaded()
                    })
                    scope.$watch('ivoiceNum', () => {
                        if (scope.ivoiceNum == 2) {
                            scope.invoiceCode = inv2Aarry[0] ? inv2Aarry[0].categoryCode : ''
                            scope.invoiceNumber = inv2Aarry[0] ? inv2Aarry[0].startNumber : ''
                        }
                        if (scope.ivoiceNum == 5) {
                            scope.invoiceCode = inv5Aarry[0] ? inv5Aarry[0].categoryCode : ''
                            scope.invoiceNumber = inv5Aarry[0] ? inv5Aarry[0].startNumber : ''
                        }
                    })
                }],
                resolve: {
                    items1() {
                        return confirmMsg
                    },
                },
                openedClass: 'mod-modal mod-modal-md',
                backdrop: 'static',
            }).result.then((result) => {
                if (result) {
                    utils.loading('开票中，请耐心等待')
                    $scope.selectedInvoiceNum = result // 选中结果
                    window.top.TaxCore.tax.invInfo(0, cbChangeUnionTypeOpen, null, null, 0)
                }
            })
        }
        const soap = (localStorage.soap && JSON.parse(localStorage.soap)) || {}

        function checkDiffInvType(invoiceDTO) { // 检查是否存在不同联次发票
            if (noUkeyId(invoiceDTO.ukeyId)) return
            if (invoiceOpenService.checkIsA9(invoiceDTO.ukeyId)) {
                utils.loading('开票打印中，请耐心等待')
                invoiceOpenService.a9OpenPrint(invoiceDTO).then(res => {
                    logger.logSuccess('开票打印成功')
                }, err => {
                    logger.logError(err)
                }).finally(() => {
                    $scope.goListPage()
                    utils.loaded()
                })
            } else if (invoiceDTO.invType === '2') {
                httpRequest.get_getTaxDisk(invoiceDTO.ukeyId).then((res) => {
                    if (res.data.value.differentInvoice === 1 && soap.status == 3) { // 普票存在不同联次发票
                        invoiceOpenService.checkWithDiskInfo([invoiceDTO]).then(()=>{
                            $scope.newOpenItem = invoiceDTO
                            $scope.printFlag = true // 是否打印
                            openIvoiceCofirm('本开票点同时存在5联式和2联式普通发票，请选择需要开具的发票联式：') // 确认后开票
                        },err=>{
                            logger.logError(err)
                        })
                    } else {
                        openAndPrint(invoiceDTO) // 直接开票
                    }
                })
            } else {
                openAndPrint(invoiceDTO) // 直接开票
            }
        }

        function checkDiffInvType2(invoiceDTO) { // 检查是否存在不同联次发票
            if (noUkeyId(invoiceDTO.ukeyId)) return
            if (invoiceOpenService.checkIsA9(invoiceDTO.ukeyId)) {
                utils.loading('开票中，请耐心等待')
                httpRequest.post_openInvoice({
                    waitId: invoiceDTO.waitId
                }).then(res => {
                    if (res.data.value.code == 0) {
                        logger.logSuccess('开票成功')
                    } else {
                        logger.logError(res.data.value.msg)
                    }
                }, err => {
                    logger.logError(err)
                }).finally(() => {
                    $scope.goListPage()
                    utils.loaded()
                })
            } else if (invoiceDTO.invType === '2') {
                httpRequest.get_getTaxDisk(invoiceDTO.ukeyId).then((res) => {
                    if (res.data.value.differentInvoice === 1 && soap.status == 3) { // 普票存在不同联次发票
                        invoiceOpenService.checkWithDiskInfo([invoiceDTO]).then(() => {
                            $scope.newOpenItem = invoiceDTO
                            $scope.printFlag = false // 是否打印
                            openIvoiceCofirm('本开票点同时存在5联式和2联式普通发票，请选择需要开具的发票联式：') // 确认后开票
                        }, err => {
                            logger.logError(err)
                        })
                    } else {
                        open(invoiceDTO) // 直接开票
                    }
                })
            } else {
                open(invoiceDTO) // 直接开票
            }
        }

        function open(invoiceDTO) {
            if (invoiceOpenService.checkIsAgent(invoiceDTO) && invoiceDTO.invType == '51') {
                utils.loading('开票中，请耐心等待')
                lastOpenStep(invoiceDTO, '开票成功', 'agentOpen')
            } else {
                utils.loading('开票中，请耐心等待')
                lastOpenStep(invoiceDTO, '开票成功', 'checkDiskAndOpen')
            }
            // else {
            //     httpRequest.get_getTaxDisk(invoiceDTO.diskId).then((res) => {
            //         if (res.data.value.differentInvoice !== 1) { // 普票存在不同联次发票
            //             utils.loading('开票中，请耐心等待')
            //         }
            //         lastOpenStep(invoiceDTO, '开票成功', 'checkDiskAndOpen')
            //     })
            // }
        }

        function lastOpenStep(item, msg, api) {
            invoiceOpenService[api](item, item.isRed).then(() => {
                logger.logSuccess(msg)
                $scope.isCancelReopenInv && cancelRewrite(0, item.waitId)
            }, (error) => {
                $scope.isCancelReopenInv && cancelRewrite(1, item.waitId)
                logger.logError(error.retmsg || error)
                $scope.isRedInfo && httpRequest.post_openingFailedBackWrite([$scope.invoice.waitId])
                $scope.isOpenRedInv && httpRequest.post_reddingFailedBackWrite([$scope.invoice.waitId])
            }).finally(() => {
                $scope.goListPage()
                utils.loaded()
            })
        }

        function openAndPrint(invoiceDTO) {
            if (invoiceDTO.invType !== '2') // 存在不同联次发票时已经加载loading
            {
                utils.loading('开票打印中，请耐心等待')
                lastOpenStep(invoiceDTO, '开票打印成功', 'checkDiskAndOpenPrint')
            } else {
                httpRequest.get_getTaxDisk(invoiceDTO.ukeyId).then((res) => {
                    if (res.data.value.differentInvoice !== 1) { // 普票不存在不同联次发票
                        utils.loading('开票打印中，请耐心等待')
                    }
                    lastOpenStep(invoiceDTO, '开票打印成功', 'checkDiskAndOpenPrint')
                })
            }
        }

        function check(invoice, callback) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (userInfo.org.invoiceFlag !== 1) {
                logger.logError('您所在机构禁止开票，请联系管理员启用')
                return
            }
            if (userInfo.sale.taxplayerType === '3' ||
                userInfo.sale.taxplayerType === '4' ||
                userInfo.sale.taxplayerType === '9') {
                logger.logError('您所在企业纳税人类型不具备开票资格')
                return
            }
            if (!operationService.hasPermit('open_invoice_z,open_eleInvoice')) {
                return
            }
            if ($scope.invoice.description && ($scope.invoice.description.slice(0, 4) == '4003' || $scope.invoice.description.slice(0, 4) == '4005')) {
                sweetalert.confirm('操作提醒', '发票上次写库失败，请先到开票软件进行发票修复后，再点击确认。避免重复开具该发票，造成跳号错觉').then(() => {
                    if (invoice.checker && invoice.payee && invoice.checker.trim() === invoice.payee.trim()) {
                        sweetalert.confirm(
                            '操作提醒',
                            '收款人和复核人为同一个人，可能影响发票的认可度，确定开票吗？',
                        ).then(() => {
                            callback(invoice)
                        })
                    } else {
                        callback(invoice)
                    }
                })
            } else if (invoice.checker && invoice.payee && invoice.checker.trim() === invoice.payee.trim()) {
                sweetalert.confirm(
                    '操作提醒',
                    '收款人和复核人为同一个人，可能影响发票的认可度，确定开票吗？',
                ).then(() => {
                    callback(invoice)
                })
            } else {
                callback(invoice)
            }
        }


        function doSubmit(invoiceDTO) {
            invoiceOpenService.scratchAndSubmit(invoiceDTO).then((res) => {
                const btns = ['开票', '取消', '开票打印']
                if (invoiceDTO.invType === '51') {
                    btns.pop()
                }
                if (res.data.value.waitInvoiceStatus === '2') {
                    window.layer.open({
                        title: '操作提醒',
                        content: '提交成功,是否继续开票，您也可以稍后在列表页面开票',
                        btn: btns,
                        yes(index) {
                            window.layer.close(index)
                            check(invoiceDTO, checkDiffInvType2)
                        },
                        btn2(index) {
                            window.layer.close(index)
                            $scope.goListPage()
                        },
                        btn3(index) {
                            window.layer.close(index)
                            check(invoiceDTO, checkDiffInvType)
                        },
                        cancel(index) {
                            window.layer.close(index)
                            $scope.goListPage()
                        },
                    })
                } else {
                    logger.logSuccess('提交成功')
                    $scope.goListPage()
                }
            })
        }

        const creatWaitAPI = $scope.isOpenRedInv ? 'post_reddingInvoice' : 'post_openingRedInfo'
        const lockAPI = $scope.isOpenRedInv ? 'post_lockOvatInvoice' : 'post_lockOvatRedInfo'

        function a9Open(invoiceDTO) {
            utils.loading('开票中，请耐心等待')
            httpRequest.post_openInvoice({
                waitId: invoiceDTO.waitId,
                deleteFlag: $scope.isRedInfo,
                reopenInvoiceId: $scope.isCancelReopenInv ? $scope.canceledInvoiceId : ''
            }).then(res => {
                if (res.data.value.code == 0) {
                    logger.logSuccess('开票成功')
                } else {
                    logger.logError(res.data.value.msg)
                }
            }).finally(() => {
                $scope.goListPage()
                utils.loaded()
            })
        }

        function noUkeyId(ukeyId) {
            if (!ukeyId) {
                logger.logError('开具失败，未选择开票点')
                return true
            }
        }
        $scope.openRedInv = function openRedInv() { // httpRequest.post_lockOvatRedInfo({ infoIds: [item.infoId], 
            const invoiceDTO = $scope.invoice.toWaitDTO()
            if (noUkeyId(invoiceDTO.ukeyId)) return
            const openCb = invoiceOpenService.checkIsA9(invoiceDTO.ukeyId) ? a9Open : invoiceDTO.invType == 2 ? checkDiffInvType2 : open
            buyerChecker.checkBuyerCreditCode(invoiceDTO.custCreditCode, invoiceDTO.creditType).then(() => {
                const error = submitCheck(invoiceDTO)
                if (error) {
                    logger.logError(error)
                    return
                }
                if ($scope.isCancelReopenInv) { //发票重开
                    utils.loading('正在保存，请稍候')
                    invoiceDTO.originalInvoiceId = $scope.canceledInvoiceId
                    if (invoiceDTO.isRed === '1') {
                        httpRequest.post_checkOvatInvoiceList({
                            invoiceCode: invoiceDTO.blueInvoiceCode,
                            invoiceNumber: invoiceDTO.blueInvoiceNumber,
                            invoiceType: invoiceDTO.invType,
                        }).then((res) => {
                            if (res.data.value) {
                                invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                                    utils.loaded()
                                    check(invoiceDTO, openCb)
                                })
                            } else {
                                utils.loaded()
                                sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                                    invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                                        check(invoiceDTO, openCb)
                                    })
                                })
                            }
                        }, (error) => {
                            utils.loaded()
                            logger.logError(error)
                        })
                    } else {
                        invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                            utils.loaded()
                            check(invoiceDTO, openCb)
                        }, (error) => {
                            utils.loaded()
                            logger.logError(error)
                        })
                    }
                } else {
                    if (!$scope.isOpenRedInv && (!$scope.invoice.customer.custAddress || !$scope.invoice.customer.custBank)) {
                        return logger.logError('购方地址/电话、开户行及账号不能为空，请完善信息')
                    }
                    utils.loading('正在保存，请稍候')
                    httpRequest[creatWaitAPI](invoiceDTO).then((res) => {
                        if (res.data.success && res.data.value) {
                            const waitInvoice = res.data.value
                            const params = $scope.isOpenRedInv ? {
                                invoiceIds: [$scope.parentInvoiceId],
                                isLock: '1',
                            } : {
                                infoIds: [$scope.parentInvoiceId],
                                isLock: '1',
                            }
                            httpRequest[lockAPI](params).then(() => { // 锁票
                                utils.loaded()
                                if (waitInvoice.waitInvoiceStatus === '2') {
                                    check(waitInvoice, openCb)
                                } else {
                                    $scope.goListPage()
                                }
                            }).finally(() => {
                                params.isLock = '0'
                                httpRequest[lockAPI](params) // 释放票
                            })
                        }
                    }, (error) => {
                        utils.loaded()
                        logger.logError(error)
                    })
                }
            })
        }

        function a9OpenAndPrint(invoiceDTO) {
            utils.loading('开票打印中，请耐心等待')
            httpRequest.post_openInvoice({
                waitId: invoiceDTO.waitId,
                deleteFlag: $scope.isRedInfo,
                reopenInvoiceId: $scope.isCancelReopenInv ? $scope.canceledInvoiceId : ''
            }).then(res => {
                if (res.data.value.code == 0) {
                    invoiceOpenService.printHelperPrint(invoiceDTO).then(() => {
                        logger.logSuccess('开票打印成功')
                    }, err => {
                        logger.logError(err)
                    }).finally(() => {
                        $scope.goListPage()
                        utils.loaded()
                    })
                } else {
                    $scope.goListPage()
                    utils.loaded()
                    logger.logError(res.data.value.msg)
                }
            })
        }
        $scope.openRedInvAndPrint = function openRedInvAndPrint() { // openAndPrint
            const invoiceDTO = $scope.invoice.toWaitDTO()
            if (noUkeyId(invoiceDTO.ukeyId)) return
            const openCb = invoiceOpenService.checkIsA9(invoiceDTO.ukeyId) ? a9OpenAndPrint : invoiceDTO.invType == 2 ? checkDiffInvType : openAndPrint
            buyerChecker.checkBuyerCreditCode(invoiceDTO.custCreditCode, invoiceDTO.creditType).then(() => {
                const error = submitCheck(invoiceDTO)
                if (error) {
                    logger.logError(error)
                    return
                }
                if ($scope.isCancelReopenInv) { //发票重开
                    utils.loading('正在保存，请稍候')
                    invoiceDTO.originalInvoiceId = $scope.canceledInvoiceId
                    if (invoiceDTO.isRed === '1') {
                        httpRequest.post_checkOvatInvoiceList({
                            invoiceCode: invoiceDTO.blueInvoiceCode,
                            invoiceNumber: invoiceDTO.blueInvoiceNumber,
                            invoiceType: invoiceDTO.invType,
                        }).then((res) => {
                            if (res.data.value) {
                                invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                                    utils.loaded()
                                    check(invoiceDTO, openCb)
                                })
                            } else {
                                utils.loaded()
                                sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                                    invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                                        check(invoiceDTO, openCb)
                                    })
                                })
                            }
                        }, (error) => {
                            utils.loaded()
                            logger.logError(error)
                        })
                    } else {
                        invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                            utils.loaded()
                            check(invoiceDTO, openCb)
                        }, (error) => {
                            utils.loaded()
                        })
                    }
                } else {
                    utils.loading('正在保存，请稍候')
                    httpRequest[creatWaitAPI](invoiceDTO).then((res) => {
                        if (res.data.success && res.data.value) {
                            const waitInvoice = res.data.value
                            const params = $scope.isOpenRedInv ? {
                                invoiceIds: [$scope.parentInvoiceId],
                                isLock: '1',
                            } : {
                                infoIds: [$scope.parentInvoiceId],
                                isLock: '1',
                            }
                            httpRequest[lockAPI](params).then(() => { // 锁票
                                utils.loaded()
                                if (waitInvoice.waitInvoiceStatus === '2') {
                                    check(waitInvoice, openCb)
                                } else {
                                    $scope.goListPage()
                                }
                            }).finally(() => {
                                params.isLock = '0'
                                httpRequest[lockAPI](params) // 释放票
                            })
                        }
                    }, (error) => {
                        utils.loaded()
                        logger.logError(error)
                    })
                }
            })
        }
        $scope.submit = function submit() {
            const invoiceDTO = $scope.invoice.toWaitDTO()
            buyerChecker.checkBuyerCreditCode(invoiceDTO.custCreditCode, invoiceDTO.creditType).then(() => {
                const error = submitCheck(invoiceDTO)
                if (error) {
                    logger.logError(error)
                    return
                }
                if (invoiceDTO.isRed === '1') {
                    httpRequest.post_checkOvatInvoiceList({
                        invoiceCode: invoiceDTO.blueInvoiceCode,
                        invoiceNumber: invoiceDTO.blueInvoiceNumber,
                        invoiceType: invoiceDTO.invType,
                    }).then((res) => {
                        if (res.data.value) {
                            doSubmit(invoiceDTO)
                        } else {
                            sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                                doSubmit(invoiceDTO)
                            })
                        }
                    })
                } else {
                    doSubmit(invoiceDTO)
                }
            })
        }

        $scope.isListDisabled = function isListDisabled() {
            const {
                invoice,
            } = $scope
            const {
                details,
            } = invoice
            return (details[0] && details[0].balance !== 0) || details.length > invoice.getMaxRow()
        }

        /**
         * 红票专属方法  根据备注查找蓝票
         */
        $scope.remarkChange = function remarkChange() {
            const {
                invoice,
            } = $scope
            if (invoice.remark === '' || invoice.isRed === '0') {
                return
            }
            const remark = invoice.remark.replace(/\s/g, '')
            let invoiceCodeLabel = '对应正数发票代码'
            let invoiceNumberLabel = '号码'
            if (invoice.isRed === '1' && (invoice.redApplicant === '0' || invoice.redApplicant === '2')) {
                invoiceCodeLabel = '对应蓝字专用发票代码'
            }
            const invCodeIndex = remark.indexOf(invoiceCodeLabel)
            const invNumIndex = remark.indexOf(invoiceNumberLabel)
            if (invCodeIndex === -1 || invNumIndex === -1) {
                logger.logError('您输入的发票代码号码备注格式不正确')
                return
            }
            let invoiceCodeReg
            if (invoice.invType === '51') {
                // 电子票
                invoiceCodeReg = /^[\d]{12}$/
            } else {
                // 纸质
                invoiceCodeReg = /^[\d]{10}$|^[\d]{12}$/
            }
            const invoiceNumReg = /^[\d]{8}$/
            let blueInvoice = utils.getBlueInvoiceFromRemark({
                remarks: remark,
                invoiceCodeLabel,
                invoiceNumberLabel
            })
            const blueInvoiceCode = blueInvoice.blueInvoiceCode
            const blueInvoiceNumber = blueInvoice.blueInvoiceNumber
            if (blueInvoiceCode === invoice.blueInvoiceCode && invoice.blueInvoiceNumber === blueInvoiceNumber) {
                return
            }
            if (!invoiceCodeReg.test(blueInvoiceCode)) {
                return
            }
            if (!invoiceNumReg.test(blueInvoiceNumber)) {
                return
            }
            invoice.remark = remark
            invoice.blueInvoiceCode = blueInvoiceCode
            invoice.blueInvoiceNumber = blueInvoiceNumber
            const req = {
                pageNum: 1,
                pageSize: 5,
                param: {
                    invType: invoice.invType,
                    invoiceCode: blueInvoiceCode,
                    invoiceNumber: blueInvoiceNumber,
                },
            }
            httpRequest.post_getNormalBlueInvoice(req).then((res) => {
                const blueList = res.data.value.list
                if (!blueList || !blueList.length) {
                    return
                }
                httpRequest.post_getOvatInvoice(blueList[0].invoiceId).then((res1) => {
                    const blueInvoice = res1.data.value
                    $scope.blueInvoice = blueInvoice
                    $scope.invoice.fromBlue(blueInvoice)
                    if (res1.data.value.isList == 1) {
                        httpRequest.post_getPageInvoiceDetail({
                            pageNum: 0,
                            pageSize: 0,
                            param: {
                                invoiceID: $scope.invoiceId,
                            },
                        }).then(response => {
                            $scope.newList = response.data.value.list
                        })
                    }

                })
            })
        }

        function cancelRewrite(reopenRet, waitId) {
            httpRequest.post_writeBackReopenInvoice({
                invoiceId: $scope.canceledInvoiceId,
                reopenRet,
                waitId
            })
        }
        $scope.scanErrorHandle = function scanErrorHandle() {
            $uibModal.open({
                templateUrl: 'scanError.html',
                openedClass: 'mod-modal mod-modal-md',
                animation: true,
                controller: ['$scope', '$uibModalInstance', 'globalFn', 'logger', function ($scope, $uibModalInstance, globalFn, logger) {
                    $scope.cancel = function cancel() {
                        $uibModalInstance.close()
                    }
                    $scope.continueScan = function continueScan() {
                        $uibModalInstance.close(true)
                    }
                }]
            }).result.then((res) => {
                if (res) {
                    $scope.scanLoading()
                }
            })
        }

        $scope.scanLoading = function scanLoading() {
            $uibModal.open({
                templateUrl: 'scanLoading.html',
                openedClass: 'mod-modal mod-modal-md',
                animation: true,
                controller: ['$scope', '$uibModalInstance', 'httpRequest', '$timeout', function ($scope, $uibModalInstance, httpRequest, $timeout) {
                    setTimeout(() => {
                        $('#scanCodeResult').on('focusout', () => {
                            setTimeout(() => {
                                $('#scanCodeResult').focus()
                            }, 10)
                        })
                    })
                    let clock

                    function clockHandle() {
                        clock = setTimeout(() => {
                            $uibModalInstance.close({
                                timeout: true
                            })
                        }, 30000)
                    }
                    clockHandle()
                    $scope.scanCodeResult = ''
                    // 扫描枪
                    document.onkeydown = (e) => {
                        if (e.keyCode == 13) {
                            clock && clearTimeout(clock)
                            clockHandle()
                            if (!$scope.scanCodeResult) {
                                return logger.logError('没有扫描到数据')
                            }
                            httpRequest.post_scanGetInvoiceTitle($scope.scanCodeResult).then(response => {
                                if (response.data && response.data.value) {
                                    let res = {
                                        result: response.data.value
                                    }
                                    $uibModalInstance.close(res)
                                } else {
                                    $uibModalInstance.close({})
                                }
                            }).catch(err => {
                                $uibModalInstance.close({})
                            })
                            $scope.scanCodeResult = ''
                        }
                    }
                    $scope.cancel = function cancel() {
                        $uibModalInstance.close()
                    }
                }]
            }).result.then(res => {
                if (res) {
                    if (res.result) {
                        let result = res.result
                        $scope.invoice.customer.custName = result.customerName
                        $scope.invoice.customer.creditType = result.taxplayerType
                        $scope.invoice.customer.custCreditCode = result.creditCode
                        $scope.invoice.customer.custAddress = result.businessAddress
                        $scope.invoice.customer.custBank = result.bank
                    } else if (res.timeout) {
                        logger.logError('扫描已超时,请重新扫描!')
                    } else {
                        $scope.scanErrorHandle()
                    }
                } else {
                    logger.logSuccess('已退出扫描')
                }
            })
        }
        $scope.openInvoiceList = function openInvoiceList() {
            const modalInstance = $uibModal.open({
                template: modalInvoiceTitle,
                controller: 'invoiceTitleModalCtrl',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-invoice-title-detail collection-invoice-detail',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return {}
                    },
                },
            })
            modalInstance.result.then((res) => {
                if (!res) return
                updateScanlen()
                let {
                    bankAccount,
                    creditCode,
                    address,
                    bankName,
                    custName,
                    email,
                    message,
                    mobile,
                    phone,
                    taxplayerType
                } = res
                $scope.invoice.customer.custCreditCode = creditCode
                $scope.invoice.customer.custName = custName
                $scope.invoice.customer.creditType = taxplayerType
                $scope.invoice.customer.custAddress = (address || phone) ? address + ' ' + phone : ''
                $scope.invoice.customer.custBank = (bankName || bankAccount) ? bankName + ' ' + bankAccount : ''
                $scope.invoice.customer.custMobile = mobile
                $scope.invoice.customer.custEmail = email
            }, () => {})
        }

        function updateScanlen() {
            $scope.wsypageRequestDTO = {
                pageNum: 1,
                pageSize: 1,
                param: {
                    custName: '',
                    creditCode: '',
                    mobile: '',
                    startDate: '',
                    endDate: '',
                    departmentName: '',
                    useStatus: '0',
                },
            };
            httpRequest.post_getSysDepartmentQrCust($scope.wsypageRequestDTO).then(res => {
                if (res.data.success) {
                    $scope.scanTitleLen = res.data.value.total;
                }
            });
        }

    }
}
InvoiceEditCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', '$http', 'logger', 'invoiceOpenService', 'sweetalert', 'operationService', '$uibModal', 'scrollService', '$filter', 'buyerChecker']


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/InvoiceEditCtrl.js